import React, { createContext, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!sessionStorage.getItem("access")
  );

  const login = (token) => {
    sessionStorage.setItem("access", token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    sessionStorage.removeItem("access");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};